import { useProcessInstanceId, useProcessInstanceUrl } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import useProcessInstanceService from 'domain/gpo/cockpit/instance/processInstanceService';
import React, { ReactNode } from 'react';
import useBpmnJs from 'domain/gpo/cockpit/facade/useBpmnJs';
import { Show } from 'framework/show';
import { ShowPageLayout } from 'framework/ui/layout';
import ProcessInstanceEntityHeader from 'domain/gpo/cockpit/instance/shared/header';
import ProcessInstanceBreadcrumbs from 'domain/gpo/cockpit/instance/shared/ProcessInstanceBreadcrumbs';
import ProcessDiagram from 'domain/gpo/cockpit/facade/diagram/ProcessDiagram';
import ProcessInstanceMenu from 'domain/gpo/cockpit/instance/shared/ProcessInstanceMenu';
import { useLocation } from 'react-router-dom';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';
import TerminateProcessButton from 'domain/gpo/cockpit/instance/Show/shared/button/TerminateProcessButton';
import { Box } from '@mui/material';

interface Props {
  children: ReactNode;
}

const ProcessInstanceShowPage = ({ children }: Props) => {
  const id = useProcessInstanceId();
  const { getById } = useProcessInstanceService();
  const bpmnJs = useBpmnJs();

  const {
    getHistoryUrl,
    getIssuesUrl,
    getVariablesUrl,
    getSubprocessesUrl,
    getTokenModificationsUrl,
    getIncidentsUrl,
    getTracingUrl,
  } = useProcessInstanceUrl();
  const location = useLocation();
  const BreadcrumbMenuItem = () => {
    let breadcrumbText;
    switch (location.pathname) {
      case getHistoryUrl(id):
        breadcrumbText = 'History';
        break;
      case getIssuesUrl(id):
        breadcrumbText = 'Issues';
        break;
      case getVariablesUrl(id):
        breadcrumbText = 'Variables';
        break;
      case getSubprocessesUrl(id):
        breadcrumbText = 'Subprocesses';
        break;
      case getTracingUrl(id):
        breadcrumbText = 'Tracing';
        break;
      case getTokenModificationsUrl(id):
        breadcrumbText = 'Token Modifications';
        break;
      case getIncidentsUrl(id):
        breadcrumbText = 'Incidents';
        break;
      default:
        breadcrumbText = null;
    }
    return breadcrumbText ? <BreadcrumbItem>{breadcrumbText}</BreadcrumbItem> : <></>;
  };

  return (
    <Show getDataMethod={() => getById(id)}>
      <ShowPageLayout
        entityHeader={<ProcessInstanceEntityHeader />}
        menu={<ProcessInstanceMenu />}
        breadcrumbs={
          <ProcessInstanceBreadcrumbs>
            <BreadcrumbMenuItem />
          </ProcessInstanceBreadcrumbs>
        }
        headerButtons={[<TerminateProcessButton />]}
      >
        <ProcessDiagram instanceId={id} bpmnJs={bpmnJs} />
        <Box mt={5}>
          {/* @ts-ignore */}
          {React.Children.map(children, child => React.cloneElement(child, { bpmnJs }))}
        </Box>
      </ShowPageLayout>
    </Show>
  );
};

export default ProcessInstanceShowPage;
